import styled from 'styled-components';

export const PagesGridSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 14px;
  row-gap: 24px;
  margin: 20px;
  @media (min-width: 768px) {
    // width: 70%;
    margin: auto;
    gap: 36px;
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const PageGridItem = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.18);
  padding-bottom: 8px;
  width: 100%;
  transition: all 0.2s linear;
  &.lowOpacity {
    opacity: 0.4;
  }
  .imgWrapper {
    margin-bottom: 16px;
    width: 100%;
    position: relative;

    padding-top: ${(props) => (props.squareImage ? '100%' : '130%')};

    img {
      border-top-right-radius: 8px !important;
      border-top-left-radius: 8px !important;
    }
    @media (min-width: 768px) {
      cursor: pointer;
    }
  }
  .title {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 600;
    font-size: clamp(14px, 2vw, 18px);
    margin-bottom: 8px;
    padding: 0 8px;
  }
  .count {
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
    font-size: clamp(13px, 2vw, 17px);
    padding: 0 8px;
  }
  @media (min-width: 768px) {
    &:hover {
      transform: translate(0, -20px);
    }
  }
`;

export const ColorPageTop = styled.div`
  width: 100%;
  background: url('https://images.myloapp.in/NestJsUploads/1717747330167-mweb-image.webp')
    center center no-repeat;
  background-size: cover;
  .overlay {
    background-color: rgba(0, 0, 0, 0.8);
    text-align: center;
    padding: 30px 0;
    h1 {
      color: #fff;
      font-weight: 600;
      font-size: clamp(22px, 4vw, 48px);
      padding: 10px 50px;
      @media (min-width: 768px) {
        width: 70%;
        margin: auto;
      }
    }
    p {
      color: #fff;
      font-size: clamp(14px, 3vw, 22px);
      font-weight: 400;
      line-height: 1.36;
      padding: 10px 30px;
      @media (min-width: 768px) {
        width: 70%;
        margin: auto;
      }
    }
  }
  @media (min-width: 768px) {
    background: url('https://images.myloapp.in/NestJsUploads/1718017829169-dweb-image-(1).webp')
      center center no-repeat;
  }
`;

export const ColorPageSectionHeading = styled.h2`
  font-size: clamp(18px, 3vw, 24px);
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  padding-left: 20px;
  margin-top: 10px;
  @media (min-width: 768px) {
    width: ${(props) => (props.faq ? '80%' : '100%')};
    margin: 10px auto 30px;
    padding: 0;
  }
`;

export const FaqQues = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 0;
  img {
    width: 16px;
    height: 16px;
    transition: all 0.3s linear;
    &.closed {
      rotate: 180deg;
    }
  }
  p {
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.87);
  }
`;

export const FaqAns = styled.p`
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-weight: 400;
  transition: all 0.3s linear;
  overflow: hidden;
  max-height: 10vh;
  &.collapsed {
    max-height: 0;
    padding-bottom: 0;
  }
  padding-bottom: 10px;
`;

export const FlexHeading = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0 20px 20px;
  justify-content: space-between;
  h2 {
    font-size: clamp(18px, 3vw, 24px);
    color: rgba(0, 0, 0, 0.87);
    flex-basis: 55%;
  }

  p {
    font-size: clamp(14px, 2vw, 18px);
    color: #2779f6;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
    img {
      width: 20px;
      height: 20px;
      @media (min-width: 768px) {
        width: 24px;
        height: 24px;
      }
    }
    &.lowOpacity {
      opacity: 0.4;
    }
    @media (min-width: 768px) {
      cursor: pointer;
    }
  }
  @media (min-width: 768px) {
    // width: 70%;
    margin: auto;
    padding: 0 0 20px;
  }
`;

export const ImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 14px;
  row-gap: 24px;
  margin: 20px;

  .gridItem {
    border-radius: 8px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.18);
    background-color: #fff;

    &.lowOpacity {
      opacity: 0.4;
    }
  }

  .wrapper {
    position: relative;
    padding-top: 130%;
    padding-bottom: 20px;

    .downloadIcon {
      position: absolute;
      right: 10px;
      bottom: 0px;
      z-index: 10;
      width: 20px;
      height: 20px;
    }
  }

  p {
    font-size: clamp(14px, 3vw, 20px);
    color: rgba(0, 0, 0, 0.87);
    font-weight: 600;
    padding: 12px;
    display: flex;
    align-items: flex-start;
    min-height: 90px;
    gap: 4px;

    img {
      width: 26px;
      height: 26px;
    }
  }

  @media (min-width: 768px) {
    // width: 70%;
    margin: auto;
    gap: 36px;
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const FaqContainer = styled.div`
  margin: 0px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  @media (min-width: 768px) {
    width: 80%;
    margin: auto;
  }
`;

export const MainContainerWithAds = styled.div`
  width: 90%;
  margin-left: auto;
  display: flex;
  align-items: flex-start;
  gap: 30px;
  justify-content: flex-start;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Container = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 71%;
  }
`;
